import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { Card, LoadingSpinner } from '../../../components';
import { useGetExamEventSettings } from '../../../hooks';
import { PATHS } from '../../constants';

import { QuestionnaireSwitcher } from './containers';

function Questionnaire() {
  const { examCardId } = useParams();
  const { t } = useTranslation();

  const { isLoading, settings } = useGetExamEventSettings({
    cardId: examCardId as string,
  });

  return (
    <div className='flex-1 overflow-y-auto py-6'>
      <Card className='mx-auto max-w-7xl gap-6'>
        <div className='flex flex-col gap-2'>
          <div className='flex items-center gap-3'>
            <div className='bg-primary h-7 w-1' />
            <h5>{t('questionnaire.title')}</h5>
          </div>
          <p className='text-sm'>{t('questionnaire.description')}</p>
        </div>
        {isLoading ? (
          <div className='flex min-h-48 items-center justify-center'>
            <LoadingSpinner />
          </div>
        ) : (
          <QuestionnaireSwitcher templateId={settings.questionnaire} />
        )}
      </Card>
    </div>
  );
}

const QuestionnaireRoute = {
  path: PATHS.Exam.Questionnaire,
  element: <Questionnaire />,
};

export default QuestionnaireRoute;
